
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/anti-piracy",
      function () {
        return require("private-next-pages/anti-piracy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/anti-piracy"])
      });
    }
  